import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade, DeliveryMode } from '@spartacus/cart/base/root';
import {
  CheckoutConfigService,
  CheckoutDeliveryModeComponent,
  CheckoutStepService,
} from '@spartacus/checkout/base/components';
import { CheckoutDeliveryModesFacade } from '@spartacus/checkout/base/root';
import { isEqual, uniqWith } from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { CheckoutFormService } from 'src/app/core/checkout/facade/checkout-form.service';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { FREIGHT, SnahCountryService } from 'src/app/service/snah/snah-countries.service';

@Component({
  selector: 'app-checkout-delivery-mode',
  templateUrl: './checkout-delivery-mode.component.html',
  styleUrls: ['./checkout-delivery-mode.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CheckoutFormService, AsyncPipe],
  standalone: false,
})
export class ShimanoCheckoutDeliveryModeComponent extends CheckoutDeliveryModeComponent implements OnInit {
  isDeliveryModeChanged = false;
  currentDeliveryModeId: string;
  currentCartSubsciption$: Subscription;
  freightStatus: boolean;
  showActiveSnahCountry$: Observable<boolean> = this.SnahCountryService.getSnahFeatures(FREIGHT);
  showActiveSnahCountry: any = this.pipeAsync.transform(this.showActiveSnahCountry$);

  constructor(
    fb: FormBuilder,
    checkoutDeliveryService: CheckoutDeliveryModesFacade,
    // routingService: RoutingService,
    checkoutConfigService: CheckoutConfigService,
    public activeCartFacade: ActiveCartFacade,
    activatedRoute: ActivatedRoute,
    checkoutStepService: CheckoutStepService,
    private spaFb: FormBuilder,
    private baseStoreService: BaseStoreService,
    private checkoutFormService: CheckoutFormService,
    protected cartExtendService: CartExtendService,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService,
    protected cartService: ActiveCartFacade,
    private componentService: ComponentService,
    private SnahCountryService: SnahCountryService,
    private pipeAsync: AsyncPipe
  ) {
    super(fb, checkoutConfigService, activatedRoute, checkoutStepService, checkoutDeliveryService, activeCartFacade);
  }

  ngOnInit() {
    this.currentCartSubsciption$ = this.componentService.hasFreeFreight$.subscribe((data) => {
      this.freightStatus = data;
      this.cdr.detectChanges();
    });
    this.supportedDeliveryModes$ = this.baseStoreService.getBasestoreData(false).pipe(
      take(1),
      map((baseStoreData) => {
        // set defaultDeliveryMode as first option in dropdown
        let sortedDeliveryModes: DeliveryMode[] = [];
        if (
          baseStoreData.defaultDeliveryMode &&
          baseStoreData.deliveryModes.deliveryModes.some(
            (deliveryMode: DeliveryMode) => deliveryMode.code === baseStoreData.defaultDeliveryMode.code
          )
        ) {
          sortedDeliveryModes = uniqWith(
            [].concat(baseStoreData.defaultDeliveryMode, baseStoreData.deliveryModes.deliveryModes).filter(Boolean),
            isEqual
          );
        } else {
          sortedDeliveryModes = baseStoreData.deliveryModes.deliveryModes;
        }
        if (this.showActiveSnahCountry && !this.freightStatus) {
          return (sortedDeliveryModes = sortedDeliveryModes.filter((data) => data.code !== 'free-ground-freight'));
        } else {
          return sortedDeliveryModes;
        }
      }),
      tap((deliveryModes) => {
        if (deliveryModes.length && !this.isDeliveryModeChanged) {
          this.currentDeliveryModeId = deliveryModes[0].code;
          this.componentService.setSelectedDeliveryModeSNAH(deliveryModes[0].code);
          this.mode = this.spaFb.group({
            deliveryModeId: [deliveryModes[0].code, Validators.required],
          });
          this.setDeliveryMode();
        }
      })
    );
  }

  changeMode(code: string): void {
    if (code !== this.currentDeliveryModeId) {
      this.currentDeliveryModeId = code;
      this.setDeliveryMode();
      this.isDeliveryModeChanged = true;
      this.componentService.setSelectedDeliveryModeSNAH(code);
    }
  }

  setDeliveryMode(): void {
    if (this.mode.valid && this.mode.value) {
      if (!this.currentDeliveryModeId) {
        this.currentDeliveryModeId = this.mode.value.deliveryModeId;
      }
      this.checkoutFormService.updateCheckoutForm(this.mode.value);
    }
  }

  ngOnDestroy() {
    if (this.currentCartSubsciption$) {
      this.currentCartSubsciption$.unsubscribe();
    }
  }
}
